import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { ErrorService } from 'services/error-service';
import { ThreadTypeService } from 'services/thread-type-service';
import { Models } from 'models/core';

@autoinject
export class ThreadTypeList {
  private tableData: Array<Models.ThreadType>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private threadTypeService: ThreadTypeService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('threadTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.threadTypeService
      .getAll('?$orderby=Name')
      .then((res) => {
        this.ready = true;
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('thread-type-detail', { Id: id });
  }
}
